import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferPriority } from 'app/shared/models/class/offerPriority/OfferPriority';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-offer-priority-solo',
  templateUrl: './admin-offer-priority-solo.component.html',
  styleUrls: ['./admin-offer-priority-solo.component.scss']
})
export class AdminOfferPrioritySoloComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() clubCode: string;

  valueInput: string;
  offersNoPriorityFiltered: FullOffer[] = [];
  offersNoPriority: FullOffer[] = [];
  offersPriority: FullOffer[] = [];
  offers: FullOffer[];
  offerPreview: FullOffer;
  imgDefault: string;
  dragOffer: number;
  userConnected: any;
  clubSelected: ClubDetails;
  clubDetails: ClubDetails;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private offerService: OfferService,
    private route: ActivatedRoute,
    private uiService: UiService,
    private router: Router,
    private clubService: ClubService,
  ) {
    super();
  }

  ngOnInit() {
    this.initComponent();
    this.initSub();
    if (this.clubCode) { this.getOffersByClub(); }
    this.getClubDetails();
  }

  changeDragOffer(offer: FullOffer, event): void {
    this.dragOffer = this.offersNoPriority.findIndex(o => o.offerKey === offer.offerKey);
  }

  async drop(event: CdkDragDrop<FullOffer[]>) {
    const { limitPriorities } = this.clubSelected;

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {

      if (this.offers.length > this.offersNoPriority.length) {
        if (event.container.id === 'offersPriority') {
          if (event.container.data.length < limitPriorities) {
            transferArrayItem(event.previousContainer.data,
              event.container.data,
              this.dragOffer,
              event.currentIndex);

          } else {
            this.uiService.showSnackbar(`Votre club ne peut avoir plus de ${limitPriorities} offres prioritaires`);

          }
        } else if (event.container.id === 'offersNoPriority') {
          transferArrayItem(event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex);
        }
      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
      }

      const offersNoPriority = await {
        offersPriority: event.previousContainer.data as FullOffer[],
        offersNoPriority: event.container.data as FullOffer[]
      };

      this.offersNoPriority = offersNoPriority[event.container.id];

      this.updatePriority();
    }
  }

  goToAddOffer(): void {
    this.router.navigate(['/admin/offers'], { queryParams: { clubCode: this.clubCode } });
  }

  getOffersNoPriority(offersNoPriority: FullOffer[]): FullOffer[] {
    const offersNoPriorityToFilter = [...offersNoPriority];
    const result = offersNoPriorityToFilter.filter(o => {
      for (const [key, value] of Object.entries(o)) {
        const valueOffer = [];
        valueOffer.push(value);
        if (valueOffer.join('|').toLocaleLowerCase().includes(this.valueInput)) {
          return o;
        }
      }
    });
    return this.valueInput ? result : offersNoPriority;
  }

  updatePriority(): void {
    const offerKeys = this.offersPriority.map(offer => offer.offerKey).join(';');
    const updatePriority = new OfferPriority(this.clubCode, offerKeys);

    this.offerService.updatePriorityOffers(updatePriority).subscribe({
      next: () => {
        this.getOffersByClub();
        this.getClubDetails();
      }
    });
  }

  private getOffersByClub(): void {
    this.offerService.getFullOffer(this.clubCode).subscribe({
      next: offers => {
        this.offers = [...offers];
        this.filterOfferByPriority(offers, 'init');
      },
    });
  }

  private filterOfferByPriority(offers: FullOffer[], action: string): void {
    this.offersNoPriority = offers.filter(offer => !offer.isPriority && offer.isActive);
    if (action === 'init') {
      this.offersPriority = offers.filter(offer => offer.isPriority);
    }
  }

  private getClubDetails(): void {
    this.clubService.getClubDetails().subscribe(clubDetails => {
      this.clubSelected = clubDetails.find(c => c.clubCode === this.route.snapshot.queryParams.clubCode);
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    if (this.userConnected.role === 'club') {
      this.router.navigate(['/admin/offer-priority'], { queryParams: { clubCode: this.userConnected.club_code } });
    }
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueFilterOfferPriority$.subscribe({
          next: valueInput => {
            this.valueInput = valueInput;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.clubPriorityOffer$.subscribe({
          next: clubSelected => {
            this.clubSelected = clubSelected;
            this.cdr.detectChanges();
          }
        })
      );

    if (this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin') {
      this.route.queryParams.subscribe(params => {
        this.dataService.clubCodePriorityOffer$.next(params.clubCode);
      });
      this.subscription.add(
        this.dataService.clubCodePriorityOffer$.subscribe({
          next: clubCodePriorityOffer => {
            this.clubCode = clubCodePriorityOffer;
            this.cdr.detectChanges();
          }
        })
      );
    }

  }

}
